import { PriceAndAvailabilityLine } from './models/price-and-availability-line.model';
import { PurchasePlanArchive } from './models/purchase-plan-archive.model';
import { RawMaterialDetailLine } from './models/raw-material-detail-line.model';
import { RawMaterialsFilters } from './models/raw-material-filters.model';
import { RawMaterial } from './models/raw-material.model';

export interface PurchasePlannerState {
  rawMaterials: RawMaterial[];
  details: Record<string, RawMaterialDetailLine[]>;
  prices: PriceAndAvailabilityLine[];
  filteredMaterials: RawMaterial[];
  archiveEntries: PurchasePlanArchive[];
  filters: RawMaterialsFilters;
  loading: boolean;
  error: string | null;
}

export const initialState: PurchasePlannerState = {
  rawMaterials: [],
  details: {},
  prices: [],
  filteredMaterials: [],
  archiveEntries: [],
  filters: {
    searchTerm: '',
    selectedCountries: [],
    hasDemand: false,
    hasMinDemand: false,
    selectedTypes: [],
    useArchive: true,
    archiveId: null,
  },
  loading: false,
  error: null,
};
